import { useAuth } from '@auth/hooks';
import { createPortal } from 'react-dom';
import React from 'react';
import { DEFAULT_THEME } from '@app/constants/theme';

export default function AppTheme() {
  const { user } = useAuth();

  const theme = user?.theme || DEFAULT_THEME;

  const cssVarsElement = (
    <style type="text/css">{`
          :root {
            --background-color: ${theme.backgroundColor};
            --primary-color: ${theme.primaryColor};
            --secondary-color: ${theme.secondaryColor};
            --accent-color: ${theme.accentColor};
            --font-primary-color: ${theme.fontPrimaryColor};
            --font-secondary-color: ${theme.fontSecondaryColor};
            --font-accent-color: ${theme.fontAccentColor};
          }
        `}</style>
  );

  return createPortal(cssVarsElement, document.head);
}
